import { useEffect, useState } from "react";
import { Reveal, SectionTag } from "./shared";
import { useLang } from "./i18n";

const COPY = {
  en: {
    tag: "Stories", headA: "Tomorrows already", headB: "taking shape.",
    quotes: [
      { color: "#1F5BFF", quote: "I was torn between engineering and design. My report showed spatial scores I didn't know I had — I'm now thriving in product design.", name: "Aarav Mehta", role: "Class 12, Mumbai" },
      { color: "#E84393", quote: "As a parent, you want to guide without pushing. Bright IQ gave our daughter's choices a vocabulary we could both trust.", name: "Ritu Sharma", role: "Parent, Jaipur" },
      { color: "#3AA64B", quote: "The counselor dashboard changed our career-guidance program. We finally see the whole cohort, not just the loudest voices.", name: "Fr. Thomas Kurian", role: "School Counselor, Kochi" },
    ],
  },
  hi: {
    tag: "कहानियाँ", headA: "कल की तैयारी", headB: "आज से।",
    quotes: [
      { color: "#1F5BFF", quote: "मैं इंजीनियरिंग और डिज़ाइन के बीच उलझा था। मेरी रिपोर्ट ने स्थानिक स्कोर दिखाया जिसे मैं पहचानता ही नहीं था — अब मैं प्रोडक्ट डिज़ाइन में बढ़ रहा हूँ।", name: "आरव मेहता", role: "कक्षा 12, मुंबई" },
      { color: "#E84393", quote: "अभिभावक होकर आप बिना दबाव डाले सही दिशा देना चाहते हैं। Bright IQ ने हमारी बेटी के विकल्पों को ऐसी भाषा दी जिस पर हम दोनों भरोसा कर सकते थे।", name: "ऋतु शर्मा", role: "अभिभावक, जयपुर" },
      { color: "#3AA64B", quote: "काउंसलर डैशबोर्ड ने हमारा करियर-मार्गदर्शन कार्यक्रम बदल दिया। अब हम पूरा समूह देखते हैं, सिर्फ़ सबसे ज़ोर से बोलने वालों को नहीं।", name: "फा. थॉमस कुरियन", role: "स्कूल काउंसलर, कोच्चि" },
    ],
  },
};

export default function Testimonials() {
  const { lang } = useLang();
  const [cmsQuotes, setCmsQuotes] = useState(null);
  const copy = COPY[lang];
  const quotes = lang === "hi" ? copy.quotes : (cmsQuotes || copy.quotes);

  useEffect(() => {
    fetch(`${process.env.REACT_APP_BACKEND_URL}/api/content/testimonials`)
      .then((r) => (r.ok ? r.json() : []))
      .then((d) => { if (Array.isArray(d) && d.length) setCmsQuotes(d); })
      .catch(() => {});
  }, []);

  return (
    <section id="stories" className="bg-cream border-y border-ink/10">
      <div className="max-w-7xl mx-auto px-5 sm:px-8 py-28 sm:py-36">
        <SectionTag color="#E84393">{copy.tag}</SectionTag>
        <Reveal>
          <h2 className="font-display font-bold text-3xl sm:text-5xl tracking-tight max-w-2xl text-balance leading-[1.05]">
            {copy.headA} <span className="font-serifa italic font-normal text-iqpink">{copy.headB}</span>
          </h2>
        </Reveal>
        <div className="mt-16 grid md:grid-cols-3 gap-6">
          {quotes.map((q, i) => (
            <Reveal key={q.name} delay={i * 0.12}>
              <figure data-testid={`testimonial-card-${i}`} className="rounded-3xl bg-paper border border-ink/10 p-8 h-full flex flex-col transition-all duration-500 hover:-translate-y-2 hover:shadow-[0_30px_60px_-20px_rgba(10,22,51,0.18)]">
                <span className="font-serifa text-6xl leading-[0.5] mt-4" style={{ color: q.color }}>&ldquo;</span>
                <blockquote className="mt-6 font-serifa italic text-lg leading-relaxed text-ink/80 flex-1">{q.quote}</blockquote>
                <figcaption className="mt-8 pt-6 border-t border-ink/10">
                  <div className="font-display font-bold text-sm">{q.name}</div>
                  <div className="text-xs text-ink/50 mt-0.5">{q.role}</div>
                </figcaption>
              </figure>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
